// extracted by mini-css-extract-plugin
export default {"root":"mantineAnchor_root__mvR69"};